import { jsx as _jsx } from "react/jsx-runtime";
import { colors } from '@mehilainen/mds-tokens';
import { chipClasses } from '@mui/material';
// NOTE: Do not import these from lib root (src/index)! Will cause circular deps
import { Times } from '../../../icons';
import { focusVisible, muiFocusVisibleCssClass } from '../shared';
export const getThemeChip = (tokens) => {
    var _a, _b;
    return ({
        MuiChip: {
            defaultProps: {
                deleteIcon: _jsx(Times, {}),
            },
            styleOverrides: {
                root: {
                    fontWeight: tokens.uiElementChip.fontWeight,
                    lineHeight: tokens.uiElementChip.lineHeight,
                    borderRadius: tokens.uiElementChip.borderRadius,
                    [`&.${chipClasses.clickable}`]: {
                        '&:hover': {
                            boxShadow: 'unset',
                        },
                    },
                },
                filled: {
                    color: colors.White,
                    backgroundColor: colors.Primary[500],
                    [`.${chipClasses.deleteIcon}:hover`]: {
                        color: colors.White,
                    },
                    [`&.${chipClasses.clickable}`]: {
                        '&:hover': {
                            backgroundColor: colors.Primary[600],
                        },
                        '&:active': {
                            color: colors.Primary[100],
                            backgroundColor: colors.Primary[600],
                        },
                    },
                    [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { 
                        // overwrite MUI opacity bg color
                        backgroundColor: colors.Primary[500], outlineOffset: '2px' }),
                    // TODO: It would be more nice if we had mapping to used color object from tokens
                    [`&.${chipClasses.colorError}`]: {
                        color: colors.White,
                        backgroundColor: colors.Error[500],
                        [`&.${chipClasses.clickable}`]: {
                            '&:hover': {
                                backgroundColor: colors.Error[600],
                            },
                            '&:active': {
                                color: colors.Error[100],
                                backgroundColor: colors.Error[600],
                            },
                        },
                        [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { 
                            // overwrite MUI opacity bg color
                            backgroundColor: colors.Error[500], outlineOffset: '2px' }),
                    },
                    // disabled has to be last because of CSS specificity
                    [`&.${chipClasses.disabled}`]: {
                        opacity: '1',
                        color: colors.White,
                        backgroundColor: tokens.uiElementChip.filled.disabled.backgroundColor,
                    },
                },
                outlined: {
                    color: colors.Primary[700],
                    backgroundColor: colors.Primary[100],
                    borderColor: colors.Primary[500],
                    borderStyle: 'solid',
                    borderWidth: tokens.uiElementChip.outlined.borderWidth,
                    [`&:not([class*="${chipClasses.disabled}"])`]: {
                        [`&  > .${chipClasses.icon}, & > .${chipClasses.deleteIcon}`]: {
                            color: colors.Primary[500],
                        },
                    },
                    // MUI has different color for deleteIcon on hover
                    [`.${chipClasses.deleteIcon}:hover`]: {
                        color: colors.Primary[500],
                    },
                    [`&.${chipClasses.clickable}`]: {
                        '&:hover': {
                            backgroundColor: colors.Primary[200],
                            borderColor: colors.Primary[600],
                        },
                        '&:active': {
                            color: colors.Primary[800],
                            backgroundColor: colors.Primary[200],
                            [`& > .${chipClasses.icon}, & > .${chipClasses.deleteIcon}`]: {
                                color: colors.Primary[600],
                            },
                        },
                    },
                    [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { 
                        // overwrite MUI opacity bg color
                        backgroundColor: colors.Primary[100], outlineOffset: '2px' }),
                    // TODO: It would be more nice if we had mapping to used color object from tokens
                    [`&.${chipClasses.colorError}`]: {
                        color: colors.Error[700],
                        backgroundColor: colors.Error[100],
                        borderColor: colors.Error[500],
                        [`&:not([class*="${chipClasses.disabled}"])`]: {
                            [`&  > .${chipClasses.icon}, & > .${chipClasses.deleteIcon}`]: {
                                color: colors.Error[500],
                            },
                        },
                        // MUI has different color for deleteIcon on hover
                        [`.${chipClasses.deleteIcon}:hover`]: {
                            color: colors.Error[500],
                        },
                        [`&.${chipClasses.clickable}`]: {
                            '&:hover': {
                                backgroundColor: colors.Error[200],
                                borderColor: colors.Error[600],
                            },
                            '&:active': {
                                color: colors.Error[800],
                                backgroundColor: colors.Error[200],
                                [`& > .${chipClasses.icon}, & > .${chipClasses.deleteIcon}`]: {
                                    color: colors.Error[600],
                                },
                            },
                        },
                        [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { 
                            // overwrite MUI opacity bg color
                            backgroundColor: colors.Error[100], outlineOffset: '2px' }),
                    },
                    // disabled has to be last because of CSS specificity
                    [`&.${chipClasses.disabled}`]: {
                        opacity: '1',
                        color: tokens.uiElementChip.outlined.disabled.color,
                        backgroundColor: tokens.uiElementChip.outlined.disabled.backgroundColor,
                        borderColor: colors.Gray500,
                    },
                },
                sizeSmall: {
                    height: tokens.uiElementChip.sizeSmall.height,
                    fontSize: tokens.uiElementChip.sizeSmall.fontSize,
                    paddingLeft: tokens.uiElementChip.sizeSmall.padding,
                    paddingRight: tokens.uiElementChip.sizeSmall.padding,
                    gap: tokens.uiElementChip.gap,
                    [`& > .${chipClasses.icon}, & > .${chipClasses.deleteIcon}`]: {
                        fontSize: (_a = tokens.uiElementChip.sizeSmall.icons) === null || _a === void 0 ? void 0 : _a.size,
                    },
                },
                sizeMedium: {
                    height: tokens.uiElementChip.sizeMedium.height,
                    fontSize: tokens.uiElementChip.sizeMedium.fontSize,
                    paddingLeft: tokens.uiElementChip.sizeMedium.padding,
                    paddingRight: tokens.uiElementChip.sizeMedium.padding,
                    gap: tokens.uiElementChip.gap,
                    [`& > .${chipClasses.icon}, & > .${chipClasses.deleteIcon}`]: {
                        fontSize: (_b = tokens.uiElementChip.sizeMedium.icons) === null || _b === void 0 ? void 0 : _b.size,
                    },
                },
                icon: {
                    color: 'inherit',
                    paddingRight: tokens.uiElementChip.icons.padding,
                    margin: 0,
                },
                deleteIcon: {
                    color: 'inherit',
                    paddingLeft: tokens.uiElementChip.icons.padding,
                    margin: 0,
                },
                label: {
                    display: 'flex',
                    paddingLeft: tokens.uiElementChip.label.padding,
                    paddingRight: tokens.uiElementChip.label.padding,
                },
            },
        },
    });
};
